export default __webpack_public_path__ + "static/wallpaper-2-pc-88db3cfe74a13757cc079632f9238f99.png";